<script lang="ts" setup>
import ToneSelect from "@/components/mobile/ToneSelect.vue";
import { ref, watch } from "vue";

const props = withDefaults(
  defineProps<{
    show: boolean;
    selectedToneId?: number;
    gender: number;
  }>(),
  {
    show: false,
    selectedToneId: 0,
    gender: 0,
  }
);

const emit = defineEmits<{
  (e: "update:show"): void;
  (e: "update:selectedToneId", toneId: number): void;
}>();

const stopMusic = ref(0);
const gender = ref<number>(props.gender);
watch(
  () => props.show,
  () => {
    if (!props.show) {
      stopMusic.value++;
    }
  }
);
</script>
<template>
  <VanPopup
    :show="show"
    class="max-h-[80%] overflow-hidden grid grid-rows-[auto_1fr]"
    position="bottom"
    round
    @update:show="emit('update:show')"
  >
    <div>
      <div
        class="flex items-center justify-center py-4 border-b border-b-primary"
      >
        {{ $t("story.selectVoice") }}
      </div>
      <VanTabs v-model:active="gender">
        <VanTab :title="$t(`Chats.femaleVoice`)" :name="0" />
        <VanTab :title="$t(`Chats.maleVoice`)" :name="1" />
      </VanTabs>
    </div>
    <div class="w-full overflow-y-auto flex flex-col relative p-2 gap-2">
      <ToneSelect
        :model-value="selectedToneId"
        :stop-music="stopMusic"
        @update:model-value="emit('update:selectedToneId', $event)"
        :gender="gender"
      />
    </div>
  </VanPopup>
</template>
